import * as React from "react";
import { useState } from "react";
import classNames from "classnames";
import { UnmountClosed } from "react-collapse";
import { TransactionEnum } from "../Resource/Contents";
import { TextBoxEditor } from "../../../../../../../../react-core/Html/TextBoxEditor";

interface IAdvanceSearchProps {
    transactionType: TransactionEnum;
    instrumentCode?: string;
    onChange: (instrumentCode, cNoteId) => void;
}

export const AdvancedSearch = (props: IAdvanceSearchProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [instrumentCode, setInstrumentCode] = useState(props.instrumentCode);
    const [cNoteId, setcNoteId] = useState(null);

    const ToggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const renderContractNo = () => {
        if (props.transactionType == TransactionEnum.investments) {
            return (
                <>
                    <div className="col-fluid col-max-245">
                        <TextBoxEditor label="Contract no" value={cNoteId} onChange={(e) => setcNoteId(e)} />
                    </div>
                    <div className="col-auto">
                        <div className="mt-40">or</div>
                    </div>
                </>
            );
        }
    };

    const toggleCSS = classNames("advanced-search-toggle", { "is-expanded": isOpen });

    return (
        <>
            <button
                type="button"
                className={toggleCSS}
                onClick={() => ToggleDropdown()}
                aria-expanded={isOpen}
                aria-controls="advanced-search-dropdown"
            >
                <span className="icon" aria-hidden="true"></span>Advanced search
            </button>
            <UnmountClosed isOpened={isOpen}>
                <div className="row narrow-gutter pt-24" id="advanced-search-dropdown">
                    {renderContractNo()}
                    <div className="col-fluid col-max-245">
                        <TextBoxEditor
                            label="Instrument code"
                            value={instrumentCode}
                            onChange={(e) => setInstrumentCode(e)}
                        />
                    </div>
                    <div className="col-auto">
                        <button
                            type="button"
                            className="btn secondary label-offset"
                            onClick={() => {
                                props.onChange(instrumentCode, cNoteId);
                            }}
                        >
                            Find investment
                        </button>
                    </div>
                </div>
            </UnmountClosed>
        </>
    );
};
